import request from '#api/axios';
import { queryKeyFactory } from '#api/queryKeyFactory';
import { IResponse } from '#types/api';
import {
  IGetConfirmationForm,
  IGetCustomerDetailProps,
  IGetCustomerList,
  IPatchConfirmationForm,
  IPostConfirmationForm
} from '#types/confirmationForms';
import { useQuery } from '@tanstack/react-query';

export const postConfirmationForms = async (
  id: string,
  payload: IPostConfirmationForm
) => {
  const res = await request<string>({
    method: 'post',
    url: `/confirmation-forms/${id}`,
    data: payload
  });
  //res.data: confirmationFormId
  return res.data;
};

export const patchConfirmationForms = async ({
  confirmationFormId,
  payload
}: {
  confirmationFormId: string;
  payload: IPatchConfirmationForm;
}) => {
  const res = await request({
    method: 'patch',
    url: `/confirmation-forms/${confirmationFormId}`,
    data: payload
  });

  return res.data;
};

export const getConfirmationForms = async () => {
  const res = await request<IGetConfirmationForm[]>({
    method: 'get',
    url: '/confirmation-forms'
  });

  return res.data;
};

export const useGetConfirmationForms = () => {
  return useQuery(
    queryKeyFactory.GET_CONFIRMATION_FORMS(),
    getConfirmationForms
  );
};

export const getCustomerList = async (
  pageParam?: number,
  offset = 10,
  process?: 0 | 1 | null,
  order?: 1 | 2 | 3
) => {
  const page = pageParam && pageParam - 1;

  const params = {
    page: page,
    offset,
    order: order || 1,
    process: process
  };

  if (process === null) {
    delete params.process;
  }

  const res = await request<IResponse<IGetCustomerList>>({
    method: 'get',
    url: '/confirmation-forms/coach',
    params
  });

  return res.data;
};

export const getCustomerPersonList = async ({
  personId,
  pageParam,
  offset = 10,
  process,
  order
}: {
  personId: string;
  pageParam?: number;
  offset?: number;
  process?: 0 | 1 | null;
  order?: 0 | 1;
}) => {
  const page = pageParam && pageParam - 1;

  const params = {
    page: page,
    offset,
    order: order || 1,
    process: process
  };

  if (process === null) {
    delete params.process;
  }

  const res = await request<IResponse<IGetCustomerList>>({
    method: 'get',
    url: `/confirmation-forms/coach/${personId}`,
    params
  });

  return res.data;
};

export const getCustomerDetail = async ({
  personId,
  id
}: IGetCustomerDetailProps) => {
  try {
    const res = await request<IGetConfirmationForm>({
      method: 'get',
      url: `/confirmation-forms/${personId}/${id}`
    });

    return res.data;
  } catch (e) {
    throw e;
  }
};
